import { createSelector } from 'reselect';
import { AuthStatus } from '../models';
import authSelector from './state';

export default createSelector(authSelector, (auth) =>
    auth ? auth.status || AuthStatus.Unknown : AuthStatus.Unknown,
);
